// The social screens' copy (lib/social/copy.ts holds nl and en) in the five other locales, one file
// each, so every language reads its own words instead of falling back to Dutch. The keys of
// the share sheet and invite messages live in share.ts and are not repeated here.
import { socialHubDe } from "./socialHub.de";
import { socialHubEs } from "./socialHub.es";
import { socialHubFr } from "./socialHub.fr";
import { socialHubIt } from "./socialHub.it";
import { socialHubPt } from "./socialHub.pt";

export const socialHubCopy = {
  de: socialHubDe,
  fr: socialHubFr,
  es: socialHubEs,
  it: socialHubIt,
  pt: socialHubPt,
} as const;
